<script>
export default {
    name: 'v-search-input',
    watch: {
        value: {
            immediate: true,
            handler (val, old) {
                if (val !== old) this.currentValue = val
            }
        }
    },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        props: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            currentValue: ''
        }
    },
    render () {
        const {props, currentValue, onChange, onSearch, onKeyDown} = this
        const propsData = {
            attrs: props
        }
        return (
            <el-input {...propsData} value={currentValue} onInput={onChange} nativeOnKeydown={this.onKeyDown}>
                <i slot="suffix" class="el-input__icon el-icon-search" onClick={onSearch}></i>
            </el-input>
        )
    },
    methods: {
        onChange (value) {
            this.currentValue = value
            this.$emit('input', value)
        },
        onSearch () {
            this.$emit('search')
        },
        onKeyDown (e) {
            if (e.key === 'Enter' || e.type === 'click') {
                this.onSearch()
                e.stopPropagation()
                e.preventDefault()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/framework/widgets/search-input.vue